export const useId = (prefix) =>
  `${prefix}_${(Math.random() * 100000000).toFixed(0).toString()}`
